"use client";

import React from "react";
import { Typography } from "@mui/material";
import { ScrollAwareTooltip } from "@/components/shared/ScrollAwareTooltip";
import { SxProps, Theme } from "@mui/material/styles";
import { useTextTruncation } from "@/hooks/useTextTruncation";

interface FileNameTruncatedTextProps {
  children: React.ReactNode;
  title: string;
  className?: string;
  variant?: "body1" | "body2" | "caption" | "subtitle1" | "subtitle2";
  sx?: SxProps<Theme>;
}

/**
 * Shows a tooltip with the full title only when the text is visually truncated.
 * Shared by FileUploadDisplay, FileUploadDownloadInput, and similar file rows.
 */
const FileNameTruncatedText: React.FC<FileNameTruncatedTextProps> = ({
  children,
  title,
  className,
  variant = "body2",
  sx,
}) => {
  const { ref, isTruncated } = useTextTruncation();

  return (
    <ScrollAwareTooltip title={isTruncated ? title : ""} placement="top">
      <Typography ref={ref} className={className} variant={variant} sx={sx}>
        {children}
      </Typography>
    </ScrollAwareTooltip>
  );
};

export default FileNameTruncatedText;
